import React, { FC } from 'react';
import { useSeo } from 'hooks/use-seo';

const AboutUsStructuredData: FC = () => {
    const seo = useSeo();
    const aboutPageStructuredData = {
        '@type': 'AboutPage',
        '@id': seo.canonical,
        'url': seo.canonical,
        'name': seo.title,
        'description': seo.description,
        'about': {
            '@id': 'https://cenojad.pl/#/schema/Organization/1'
        },
        'isPartOf': {
            '@id': 'https://cenojad.pl/#/schema/WebSite/1'
        }
    };

    return (
        <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{ __html: JSON.stringify(aboutPageStructuredData) }}
        />
    );
};

export default AboutUsStructuredData;
